import * as React from 'react';

import { IAddCardDiff } from '@Shared/card_statement_upload';
import { IUserModel } from '@Shared/models';

import { Select } from '@ReactComponents/Select';

import * as style from './ManualUploadSingleCardHolderMapping.styl';

interface IManualUploadSingleCardHolderMappingProps {
  addCardDiff: IAddCardDiff;
  users: IUserModel[];
  countOfNewTransactions: number;
  onChangeCardHolder: (user: IUserModel) => void;
}

export const ManualUploadSingleCardHolderMapping: React.FC<IManualUploadSingleCardHolderMappingProps> = (props) => {
  const { addCardDiff, users, countOfNewTransactions, onChangeCardHolder } = props;

  const userId = addCardDiff.userId;
  const cardHolder = users.find((user) => user.id === userId);

  const displayProviderId = addCardDiff.providerId ? addCardDiff.providerId.toUpperCase() : 'UNKNOWN';
  const displayCardHolder = addCardDiff.cardHolderName ? `'${addCardDiff.cardHolderName.toUpperCase()}'` : 'UNKNOWN';
  const displayLastFour = addCardDiff.lastFour ? `'${addCardDiff.lastFour.toUpperCase()}'` : 'UNKNOWN';
  return (
    <div className={style.global}>
      <label>Card Holder</label>
      <div className="card-holder-selector-row flex">
        <Select<IUserModel>
          options={users}
          value={cardHolder}
          onChange={onChangeCardHolder}
          getOptionLabel={(option) => option.name || option.email}
          getOptionValue={(option) => option.id}
        />
        <div className="count-of-new-transactions">{countOfNewTransactions} Transactions</div>
      </div>
      <div className="card-info">
        <div className="card-info-id">ID: {displayProviderId}</div>
        <div className="card-info-member">CARD MEMBER: {displayCardHolder}</div>
        <div className="card-info-last-four">CARD NUMBER: {displayLastFour}</div>
      </div>
    </div>
  );
};
